// src/icons/Person.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Person({
  strokeWidth = "1.5",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.7485 6.5C15.7485 8.57107 14.0696 10.25 11.9985 10.25C9.92747 10.25 8.24854 8.57107 8.24854 6.5C8.24854 4.42893 9.92747 2.75 11.9985 2.75C14.0696 2.75 15.7485 4.42893 15.7485 6.5Z",
            stroke: "currentColor",
            strokeWidth,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.9985 13.25C8.20293 13.25 5.43245 15.7735 4.67009 19.1657C4.54089 19.7406 5.0077 20.25 5.59696 20.25H18.4001C18.9894 20.25 19.4562 19.7406 19.327 19.1657C18.5646 15.7735 15.7941 13.25 11.9985 13.25Z",
            stroke: "currentColor",
            strokeWidth,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  Person
};
